import { ADMIN_REFRESH_STORAGE_KEY } from "@/api/constants";
import { getAdminApiBase } from "@/utils/env";
import type { components } from "@/api/generated/schema";

type TokenPair = components["schemas"]["AdminTokenPair"];

export async function postRefreshToken(
  refreshToken: string
): Promise<TokenPair | null> {
  const res = await fetch(`${getAdminApiBase()}/admin/v1/auth/refresh`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ refresh_token: refreshToken }),
  });
  if (!res.ok) return null;
  return (await res.json()) as TokenPair;
}

export function readRefreshToken(): string | null {
  return sessionStorage.getItem(ADMIN_REFRESH_STORAGE_KEY);
}

export function writeRefreshToken(token: string): void {
  sessionStorage.setItem(ADMIN_REFRESH_STORAGE_KEY, token);
}

export function clearRefreshToken(): void {
  sessionStorage.removeItem(ADMIN_REFRESH_STORAGE_KEY);
}
